/* GENERATED from pokemon-lab/lab/motion-core.mjs — do not edit. */
(function () {
'use strict';
/* ============================================================================
   PKX Motion Core — THE single geometry/progress contract.

   Consumed by:
   - Node unit tests (pure ESM import)
   - the Lab canvas preview (ESM import)
   - the storefront engine (tools/assemble.py wraps this file into
     theme-drop/assets/pokemon-motion-core.js exposing window.PKXMotion)

   Everything here is pure: no DOM, no timers.
   ========================================================================== */

/** Parse "x,y; x,y; …" (percent of section) into [[x,y],...]. null if <2 pts.
    An optional third number per point is that WAYPOINT's zoom in percent
    ("x,y,180") — kept as p[2]; points without one stay length-2. */
function parseRoute(str) {
  if (!str) return null;
  const pts = [];
  String(str).split(";").forEach(pair => {
    const m = pair.split(",");
    if (m.length >= 2) {
      const x = parseFloat(m[0]);
      const y = parseFloat(m[1]);
      const s = m.length >= 3 ? parseFloat(m[2]) : NaN;
      if (!isNaN(x) && !isNaN(y)) pts.push(isNaN(s) ? [x, y] : [x, y, s]);
    }
  });
  return pts.length >= 2 ? pts : null;
}

function routeToString(pts) {
  return (pts || []).map(p => `${(+p[0]).toFixed(1)},${(+p[1]).toFixed(1)}` +
    (p[2] != null && +p[2] !== 100 ? `,${Math.round(+p[2])}` : "")).join("; ");
}

/** true when any waypoint carries its own zoom value. */
function routeHasScales(pts) {
  return !!pts && pts.some(p => p[2] != null);
}

/** Cumulative segment lengths; total > 0 guaranteed for distinct points. */
function routeLengths(pts) {
  const lengths = [];
  let total = 0;
  for (let i = 1; i < pts.length; i++) {
    const d = Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]);
    lengths.push(d);
    total += d;
  }
  return { lengths, total };
}

/** Distance-based position along the polyline at t∈[0,1]. Speed is uniform
    regardless of how unevenly the waypoints are spaced. */
function routePointAt(pts, t) {
  if (!pts || !pts.length) return [0, 0];
  if (pts.length === 1) return pts[0];
  t = Math.max(0, Math.min(1, t));
  const { lengths, total } = routeLengths(pts);
  if (!total) return pts[0];
  const target = t * total;
  let acc = 0;
  for (let i = 0; i < lengths.length; i++) {
    if (acc + lengths[i] >= target - 1e-9) {
      const f = lengths[i] ? (target - acc) / lengths[i] : 0;
      return [
        pts[i][0] + (pts[i + 1][0] - pts[i][0]) * f,
        pts[i][1] + (pts[i + 1][1] - pts[i][1]) * f,
      ];
    }
    acc += lengths[i];
  }
  return pts[pts.length - 1];
}

/** Keyframe list with DISTANCE-proportional offsets (not per-point equal time):
    [{pct, dx, dy, scale}] where dx/dy are px offsets from the first point given
    the section pixel size, and scale zooms from scaleFrom% to scaleTo% along
    the path (the "3D depth" illusion). Same function feeds Lab and storefront. */
function routeKeyframes(pts, secW, secH, scaleFrom = 100, scaleTo = 100) {
  const { lengths, total } = routeLengths(pts);
  const perPoint = routeHasScales(pts);
  const sAt = (p) => (scaleFrom + (scaleTo - scaleFrom) * p) / 100;
  const sOf = (i, p) => perPoint ? (pts[i][2] ?? 100) / 100 : sAt(p);
  const frames = [{ pct: 0, dx: 0, dy: 0, scale: sOf(0, 0) }];
  if (!total) return frames;
  let acc = 0;
  for (let i = 0; i < lengths.length; i++) {
    acc += lengths[i];
    const p = acc / total;
    frames.push({
      pct: Math.round(p * 1000) / 10,
      dx: (pts[i + 1][0] - pts[0][0]) / 100 * secW,
      dy: (pts[i + 1][1] - pts[0][1]) / 100 * secH,
      scale: sOf(i + 1, p),
    });
  }
  frames[frames.length - 1].pct = 100;
  return frames;
}

/** Zoom factor along a route at progress p, from scaleFrom% to scaleTo%. */
function routeScaleAt(p, scaleFrom = 100, scaleTo = 100) {
  return (scaleFrom + (scaleTo - scaleFrom) * Math.max(0, Math.min(1, p))) / 100;
}

/** Zoom factor at progress t along a route: interpolates PER-WAYPOINT zooms
    (distance-based, like routePointAt) when any point has one, otherwise
    falls back to the linear scaleFrom→scaleTo ramp. One function for the
    Lab preview and the storefront. */
function routeScaleAtProgress(pts, t, scaleFrom = 100, scaleTo = 100) {
  if (!routeHasScales(pts)) return routeScaleAt(t, scaleFrom, scaleTo);
  t = Math.max(0, Math.min(1, t));
  const sc = (i) => (pts[i][2] ?? 100) / 100;
  const { lengths, total } = routeLengths(pts);
  if (!total) return sc(0);
  const target = t * total;
  let acc = 0;
  for (let i = 0; i < lengths.length; i++) {
    if (acc + lengths[i] >= target - 1e-9) {
      const f = lengths[i] ? (target - acc) / lengths[i] : 0;
      return sc(i) + (sc(i + 1) - sc(i)) * f;
    }
    acc += lengths[i];
  }
  return sc(pts.length - 1);
}

/* ---------------- scroll progress contracts ---------------- */

/** Viewport-transit progress −1…1 (legacy parallax/scrub basis):
    −1 = section fully below viewport, +1 = fully above. */
function viewportProgress(rectTop, rectHeight, viewportH) {
  const p = 1 - 2 * ((rectTop + rectHeight) / (viewportH + rectHeight));
  return Math.max(-1, Math.min(1, p));
}

/** Pin progress 0…1 for a sticky track: how far through the pinned stretch. */
function pinProgress(trackTop, trackHeight, viewportH) {
  const span = trackHeight - viewportH;
  if (span <= 0) return 1;
  return Math.max(0, Math.min(1, -trackTop / span));
}

/** Journey progress 0…1 of a section travelling through the screen.
    0 = the section's TOP just appeared at the BOTTOM edge of the screen.
    1 = the section's BOTTOM just left the TOP edge of the screen.
    Pure function of scroll position: deterministic, freezes exactly where
    scrolling stops, reverses smoothly on scroll-up, needs no pinning. */
function journeyProgress(rectTop, rectHeight, viewportH) {
  const total = viewportH + rectHeight;
  if (total <= 0) return 0;
  return Math.max(0, Math.min(1, (viewportH - rectTop) / total));
}

/** Crop a 0…1 journey to a start/end window given in percent.
    Before the window → 0 (frozen at first frame); after → 1 (frozen at last).
    startPct=0, endPct=100 plays across the whole journey. */
function windowProgress(journey, startPct = 0, endPct = 100) {
  const a = startPct / 100, b = endPct / 100;
  if (b <= a) return journey >= b ? 1 : 0;
  return Math.max(0, Math.min(1, (journey - a) / (b - a)));
}

/** Scroll-scrub progress 0…1: journey through the screen cropped to the
    start/end window. The one call both the Lab preview and the storefront use. */
function scrubProgress(rectTop, rectHeight, viewportH, startPct, endPct) {
  return windowProgress(journeyProgress(rectTop, rectHeight, viewportH), startPct ?? 0, endPct ?? 100);
}

/** Map raw progress through direction / start–end window / easing. */
function mapProgress(raw, opts = {}) {
  let p = Math.max(0, Math.min(1, raw));
  const from = (opts.from ?? 0) / 100;
  const to = (opts.to ?? 100) / 100;
  p = from + (to - from) * p;
  if (opts.reverse) p = 1 - p;
  return ease(opts.easing || "linear", Math.max(0, Math.min(1, p)));
}

function ease(name, t) {
  switch (name) {
    case "ease-out": return 1 - Math.pow(1 - t, 3);
    case "ease-in": return t * t * t;
    case "ease-in-out": return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    default: return t; // linear
  }
}

/** Interpolate scrub-driven visual state at progress p for a layer's motion
    settings. Returns {x, y, rot, scale, opacity} deltas/values. */
function scrubState(p, s = {}) {
  const lerp = (a, b) => a + (b - a) * p;
  return {
    x: lerp(s.from_x ?? 0, s.to_x ?? 0),
    y: lerp(s.from_y ?? 0, s.to_y ?? 0),
    rot: lerp(s.from_rot ?? 0, s.to_rot ?? 0),
    scale: lerp(s.from_scale ?? 100, s.to_scale ?? 100) / 100,
    opacity: lerp(s.from_opacity ?? 100, s.to_opacity ?? 100) / 100,
  };
}

/* ---------------- validation / limits ---------------- */

const SHOPIFY_LIMITS = { maxSections: 25, maxBlocksPerSection: 50 };

/** How many products a count setting means. countMode: number 0..100 or "all". */
function resolveProductCount(countMode, collectionSize) {
  if (countMode === "all") return collectionSize;
  const n = Math.max(0, Math.min(100, parseInt(countMode, 10) || 0));
  return Math.min(n, collectionSize);
}

window.PKXMotion = { SHOPIFY_LIMITS, ease, journeyProgress, mapProgress, parseRoute, pinProgress, resolveProductCount, routeHasScales, routeKeyframes, routeLengths, routePointAt, routeScaleAt, routeScaleAtProgress, routeToString, scrubProgress, scrubState, viewportProgress, windowProgress };
})();
